<!--
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑       永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2022-02-23 18:36:00
 * @LastEditTime: 2022-02-25 16:01:49
 * @Description: 计划详情-骨料
 * @Param:
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\supplyPlan\planDetails_gl.vue
 -->

<template>
    <div class="commonFormStyles planDetails_fl">
        <div class="info">
            <h4>场站信息：{{ planBasicInfo.station_name }}</h4>
            <p class="iconfont iconshijian">
                要求进场时间：{{ planBasicInfo.time_required }}
            </p>
            <p class="iconfont icondaqiayueli">
                计划日期：{{ planBasicInfo.supply_date }}
            </p>
            <p class="iconfont iconshijian">
                申请时间：{{ planBasicInfo.operation_date }}
            </p>
            <p class="iconfont iconwode">
                申请人：{{ planBasicInfo.operation_name }}
            </p>
        </div>
        <div class="materialList">
            <template v-for="(item, index) in planBasicMaterialList">
                <dl :key="`material_${index}`" :class="{'noDailyPlanSupplys': item.dailyPlanSupplys.length == 0}">
                    <dt v-if="item.planGoods">
                        <h3>
                            <span>{{ item.planGoods.type_name }}</span>
                            <span>{{ item.planGoods.measure_unit }}</span>
                        </h3>
                        <ul>
                            <li>
                                <h4>{{ item.planGoods.plan_count }}</h4>
                                <p>计划数量</p>
                            </li>
                            <li>
                                <h4>{{ item.planGoods.plan_supply_count }}</h4>
                                <p>已安排量</p>
                            </li>
                            <li>
                                <h4>{{ item.planGoods.is_restrict_supply }}</h4>
                                <p>是否限量</p>
                            </li>
                        </ul>
                    </dt>
                    <template v-for="(k, j) in item.dailyPlanSupplys">
                        <dd :key="`dailyPlanSupplys_${j}`">
                            <h4>
                                <span class="text">供应单号：{{ k.no }}</span>
                                <span class="state" v-if="k.is_process_contract" style="background: #02A84C;">加工商</span>
                                <span class="state" v-else style="background: #FF6702;">供应商</span>
                            </h4>
                            <div>
                                <p>
                                    <img src="@/assets/images/icons/icon_gy_8.png" alt="">
                                    <span>
                                        <template v-if="k.is_process_contract">加工商：</template>
                                        <template v-else>供应商：</template>

                                        {{ k.supplier_name }}
                                    </span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <img src="@/assets/images/icons/icon_gy_2.png" alt="">
                                    <span>货源地：{{ k.source_name }}</span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <img src="@/assets/images/icons/icon_44.png" alt="">
                                    <span>供应量：{{ k.supply_count }}</span>
                                </p>
                                <p>
                                    <img src="@/assets/images/icons/icon_44.png" alt="">
                                    <span>暗扣量：{{ k.covert_deduction_weight }}</span>
                                </p>
                            </div>
                            <div>
                                <p>
                                    <img src="@/assets/images/icons/icon_11.png" alt="">
                                    <span>运输单位：{{ k.transport_name }}</span>
                                </p>
                            </div>
                        </dd>
                    </template>
                </dl>
            </template>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            plan_id: '',
            planBasicInfo: {},
            planBasicMaterialList: [],
        };
    },
    computed: {},
    watch: {},
    async created() {
        this.plan_id = this.$route.params.plan_id;
        this.planBasicInfo = await this.getPlanBasicInfo(this.plan_id);
        this.planBasicMaterialList = await this.getPlanBasicMaterialList(this.plan_id);
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 获取计划基础信息
        getPlanBasicInfo(planId) {
            return this.$axios.$get(`/interfaceApi/procurement/daily/plan/get/${planId}`, { defEx: true });
        },

        // 获取计划骨料数据
        getPlanBasicMaterialList(planId) {
            return this.$axios.$get(`/interfaceApi/procurement/daily/plan/goods/supplyinfo/${planId}`, { defEx: true });
        },
    },
};
</script>
<style lang="stylus" scoped>
.planDetails_fl
    height 100%
    background: #F0F0F0
    .info
        padding 12rpx
        background #FFFFFF
        box-shadow 0px 0px 6px 0px rgba(0, 0, 0, 0.3)
        h4
            font-size 16rpx
            color #1F2229
            font-weight 600
        p
            flex 1
            font-size 14rpx
            color #626262
            margin-top: 8rpx
    .materialList
        padding: 14rpx
        dl
            background: #FFFFFF;
            box-shadow: 1px 1px 4px 0px rgba(84, 148, 243, 0.5);
            border: 1px solid #D7D7D7;
            margin-bottom: 14rpx
            &:last-child
                margin-bottom: 0
            &.noDailyPlanSupplys
                dt
                    margin-bottom: 0
                    &:after
                        display none
            dt
                margin-bottom: 10rpx
                &:after
                    content ''
                    display: block
                    width 100%
                    height 20rpx
                    background: url(./images/splice.png)
                    background-size: 100% 100%
                h3
                    height: 40rpx
                    line-height: 40rpx
                    font-size 18rpx
                    color #2978FF
                    padding 0 12rpx
                    background: rgba(85, 136, 241, 0.06)
                    font-family youSheBiaoTiHei
                    display flex
                    justify-content space-between
                ul
                    display: flex
                    padding 3rpx 7rpx
                    li
                        flex 1
                        margin: 7rpx
                        background: #F8F8F8
                        text-align: center
                        line-height: 20rpx
                        h4
                            font-size 16rpx
                            color #1F2229
                        p
                            font-size 12rpx
                            color #666666

            dd
                h4
                    padding-left 12rpx
                    font-size 16rpx
                    color #1F2229
                    display flex
                    justify-content space-between
                    align-items center
                    margin-bottom 12rpx
                    .text
                        font-weight 500
                    .state
                        height: 20rpx;
                        background: #02A84C;
                        border-radius: 20rpx 0 0 20rpx;
                        font-size 12rpx
                        color #fff
                        line-height: 20rpx
                        padding 0 5rpx 0 10rpx
                div
                    width 100%
                    padding 0 12rpx
                    margin-bottom 12rpx
                    display flex
                    justify-content space-between
                    p
                        flex 1
                        overflow hidden
                        // &:nth-of-type(2)
                        //     text-align: right
                        img,span
                            float left
                            height 16rpx
                            line-height 16rpx
                        img
                            width 16rpx
                            margin-right 12rpx
                        span
                            display inline-block
                            width calc(100% - 40rpx)
                            overflow hidden
                            text-overflow ellipsis
                            white-space nowrap
                            font-size 14rpx
                            color #666666
</style>